import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import logo from "../../../assets/logo.png";
import { API_BASE_URL } from "../../../config";



const PoolCareSwapDeal = () => {
  const { dealId } = useParams();

  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user?.id;

 const [deal, setDeal] = useState(null);
const [listingA, setListingA] = useState(null);
const [listingB, setListingB] = useState(null);
  const [loading, setLoading] = useState(true);
  const [confirming, setConfirming] = useState(false);
  const [handoverMessage, setHandoverMessage] = useState("");
  const [handoverState, setHandoverState] = useState(null);
// null | "waiting" | "completed"


  /* =========================
     LOAD DEAL
  ========================= */
  const loadDeal = async () => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/api/poolcare/swaps/deal/${dealId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      setDeal(res.data.deal || null);
      setListingA(res.data.listingA || null);
setListingB(res.data.listingB || null);
      setLoading(false);
    } catch (err) {
      console.error("❌ Load deal failed:", err);
      setLoading(false);
    }
  };

  useEffect(() => {
    loadDeal();
  }, [dealId]);

  if (loading) return <p style={{ padding: 20 }}>Loading…</p>;
  if (!deal) return <p style={{ padding: 20 }}>Deal not found.</p>;

  /* =========================
     ROLES
  ========================= */
  const isInitiator = userId === deal.initiatorId;
  const isReceiver = userId === deal.receiverId;

  /* =========================
     PAYMENTS (SOURCE OF TRUTH)
  ========================= */
  const initiatorPaid = deal.paymentA === 1;
  const receiverPaid = deal.paymentB === 1;

  const userPaid = isInitiator ? initiatorPaid : receiverPaid;
  const otherPaid = isInitiator ? receiverPaid : initiatorPaid;

  const bothPaid = initiatorPaid && receiverPaid;

  /* =========================
     UI RULES
  ========================= */
  const showPayButton =
    deal.swap_status === "payment_required" &&
    isInitiator &&
    deal.paymentA === 0;

  const canConfirmHandover =
    bothPaid && deal.swap_status !== "completed";

  const canViewPartner =
    bothPaid &&
    (deal.swap_status === "handover" ||
      deal.swap_status === "completed");

  /* =========================
     PARTNER DETAILS
  ========================= */
  const partnerName = isInitiator
    ? deal.receiver_name
    : deal.initiator_name;

  const partnerEmail = isInitiator
    ? deal.receiver_email
    : deal.initiator_email;

  const partnerPhone = isInitiator
    ? deal.receiver_phone
    : deal.initiator_phone;

    const partnerCompany = isInitiator
  ? deal.receiver_business_name
  : deal.initiator_business_name;

const partnerABN = isInitiator
  ? deal.receiver_abn
  : deal.initiator_abn;


  /* =========================
     PAY
  ========================= */
  const handlePaySwap = async () => {
  try {
    const res = await axios.post(
      `${API_BASE_URL}/api/poolcare/swaps/swap-payments/pay`,
      { dealId: deal.id },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    window.location.href = res.data.url;
  } catch (err) {
    console.error(err);
    alert("Failed to start payment");
  }
};

/* =========================
     CONFIRM HANDOVER
  ========================= */
const handleConfirmHandover = async () => {
  try {
    setConfirming(true);
    setHandoverMessage("");

    const res = await axios.post(
      `${API_BASE_URL}/api/poolcare/swaps/confirm-handover/${deal.id}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    if (!res.data?.success) {
      alert(res.data?.message || "Failed to confirm handover");
      return;
    }

    // ✅ SECOND USER — swap fully completed
    if (res.data.finished) {
      alert("Handover completed!");
      loadDeal();
      return;
    }

    // ✅ FIRST USER — SHOW MESSAGE ON PAGE
    setHandoverMessage(
      "✅ You have confirmed handover completion. Waiting for the other user to confirm before the swap is completed."
    );

    loadDeal();

  } catch (err) {
    console.error("Confirm handover failed:", err);
    alert("Error confirming handover");
  } finally {
    setConfirming(false);
  }
};


  return (
    <div style={{ maxWidth: 900, margin: "0 auto", padding: 20 }}>
      <img
        src={logo}
        alt="Client Exchange"
        style={{ width: 180, margin: "0 auto 30px", display: "block" }}
      />

      {/* STATUS */}
      <div className="card">
       <h3>Swap Status</h3>

{deal.swap_status === "completed" ? (
  <div
    style={{
      padding: 16,
      background: "#e8f5e9",
      border: "1px solid #81c784",
      borderRadius: 8,
      marginBottom: 15,
    }}
  >
    <h4 style={{ marginBottom: 8, color: "#2e7d32" }}>
      ✅ Swap Completed
    </h4>
    <p style={{ margin: 0 }}>
      Both parties have confirmed the handover.
      This swap is now permanently completed.
    </p>
  </div>
) : (
  <p>
    {bothPaid
      ? "Both users have paid. Confirm handover once complete."
      : userPaid
      ? "Waiting for the other user to pay."
      : "Payment required to proceed."}
  </p>
)}

{handoverMessage && (
  <div
    style={{
      marginTop: 12,
      padding: "12px 16px",
      background: "#e3f2fd",
      border: "1px solid #90caf9",
      borderRadius: 8,
      color: "#0d47a1",
      fontWeight: 500,
    }}
  >
    {handoverMessage}
  </div>
)}


        {showPayButton && (
          <button
            onClick={handlePaySwap}
            style={{
              marginTop: 15,
              width: "100%",
              padding: 12,
              background: "#2e7d32",
              color: "#fff",
              border: "none",
              borderRadius: 8,
            }}
          >
            Pay Swap Fee
          </button>
        )}
{canConfirmHandover && (
  <div style={{ marginTop: 20 }}>

    <div
      style={{
        padding: 16,
        background: "#fff8e1",
        border: "1px solid #ffe082",
        borderRadius: 8,
        marginBottom: 15,
      }}
    >
      <h4 style={{ marginBottom: 10 }}>⚠ Before You Confirm Handover</h4>

      <ul style={{ paddingLeft: 18, lineHeight: 1.6 }}>
        <li>You have physically handed over the client.</li>
        <li>All service details and access information have been transferred.</li>
        <li>You are satisfied the swap is complete.</li>
      </ul>

      <p style={{ marginTop: 10, fontSize: 14 }}>
        The swap will be permanently completed once both users confirm.
      </p>
    </div>

    <button
      onClick={() => {
        const confirmAction = window.confirm(
          "Have you physically completed the client handover?\n\nThis action cannot be undone once both parties confirm."
        );
        if (confirmAction) {
          handleConfirmHandover();
        }
      }}
      disabled={confirming}
      style={{
        width: "100%",
        padding: 12,
        background: "#d32f2f",
        color: "#fff",
        border: "none",
        borderRadius: 8,
        opacity: confirming ? 0.7 : 1,
      }}
    >
      {confirming ? "Confirming..." : "Confirm Handover (Final Step)"}
    </button>

  </div>
)}
</div>


      {/* PAYMENT STATUS */}
      <div className="card" style={{ marginTop: 20 }}>
        <h3>Payment Status</h3>
        <p>You: {userPaid ? "✔ Paid" : "❌ Not Paid"}</p>
        <p>Other User: {otherPaid ? "✔ Paid" : "⏳ Waiting"}</p>
      </div>

{/* CLIENT DETAILS */}
<div style={box}>
  <h3>Client Details</h3>

  <div style={clientGrid}>
    <div style={clientCard}>
      <h4 style={clientTitle}>Listing A</h4>

      <p>
        <strong>From:</strong>{" "}
        {listingA?.swap_from_suburb || "Not provided"}
      </p>

      <p>
        <strong>To:</strong>{" "}
        {listingA?.swap_to_suburb || "Not provided"}
      </p>
    </div>

    <div style={clientCard}>
      <h4 style={clientTitle}>Listing B</h4>

      <p>
        <strong>From:</strong>{" "}
        {listingB?.swap_from_suburb || "Not provided"}
      </p>

      <p>
        <strong>To:</strong>{" "}
        {listingB?.swap_to_suburb || "Not provided"}
      </p>
    </div>
  </div>
</div>

      {/* PARTNER DETAILS */}
      {canViewPartner && (
  <div className="card" style={{ marginTop: 20 }}>
    <h3>Swap Partner</h3>

    <p><strong>Name:</strong> {partnerName}</p>
    <p><strong>Email:</strong> {partnerEmail}</p>
    <p><strong>Phone:</strong> {partnerPhone}</p>
    <p><strong>Company:</strong> {partnerCompany || "—"}</p>
    <p><strong>ABN:</strong> {partnerABN || "—"}</p>
  </div>
)}


    </div>
  );
};


const box = {
  background: "#fff",
  padding: 20,
  marginTop: 20,
  borderRadius: 10,
  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
};

const clientGrid = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
  gap: 16,
  marginTop: 12,
};

const clientCard = {
  background: "#f8faf8",
  border: "1px solid #e1e8e1",
  borderRadius: 10,
  padding: 16,
};

const clientTitle = {
  marginTop: 0,
  marginBottom: 10,
  color: "#2e7d32",
};



export default PoolCareSwapDeal;
